import { h3ProjectionFunctions } from '../../../utils/materials/vertex-shaders/h3-projection';
import { sharedUniforms } from '../../shared/shaders/definitions';
import { getColor } from './color/get-color';
import { getPosition } from './get-position';

export const mainCloudVertexShader = `
  uniform bool hideGround;
  uniform float pointSize;

  ${sharedUniforms}
  ${h3ProjectionFunctions}
  ${getColor}
  ${getPosition}

  void main() {
    vColor = getColor();
    gl_Position = getPosition();
    gl_PointSize = pointSize;
  }
`;
